import React from "react";

export default function About() {
  return (
    <div className="flex float-right pr-[67px]">
      <div className="max-w-[720px]">
        <h2 className="font-about text-regular-blue text-[64px] leading-[77px] mb-[24px]">
          About
        </h2>
        <p className="font-main text-[20px] pb-[20px]">
          CrazyPrints is an innovative storybook creator that uses AI technology
          to create personalized, one-of-a-kind books for children and adults
          alike. Our mission is to help people become the hero of their own
          story by creating books that are tailored to their interests and
          preferences.
        </p>
        <p className="font-main text-[20px] pb-[20px]">
          Our team of developers and illustrators have worked tirelessly to
          perfect our AI algorithms, which generate unique stories and
          illustrations that are completely personalized to each user. Our
          high-quality printing ensures that every book we create is a keepsake
          that can be treasured for years to come.
        </p>
        <p className="font-main text-[20px]">
          At CrazyPrints, we believe that every person has a unique story to
          tell, and we are dedicated to helping them tell it in the most
          beautiful and personalized way possible. We are constantly updating
          and improving our technology to bring you the best possible
          experience. So why wait? Get started on your own personalized
          storybook today and become the hero of your own story with
          CrazyPrints!
        </p>
      </div>
    </div>
  );
}
